export const EARLY_CHECKIN_THRESHOLD__MINUTES = 15;
export const LATE_CHECKIN_THRESHOLD__MINUTES = 15;
